<!--
 * @Description: myredhat-web
 * @Version: 1.0
 * @Autor: 张梦洁
 * @Date: 2021-09-11 11:08:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-17 14:50:50
-->

<template>
  <div class="consultDetails">
    <div class="banner">
      <img src="@/assets/consult/consultInd.png">
    </div>
    <div class="text inner">
      <p>资讯详情</p>
      <p>&mdash;&nbsp;Information details&nbsp;&mdash;</p>
    </div>

    <!-- 轮播 -->
    <el-carousel arrow='always' trigger="click" indicator-position="none" :autoplay='false' class="topBanner inner" height="490px">
      <el-carousel-item class="lease" v-for="item in consultDetailsList" :key="item.id">
        <div class="consultDetailsCon inner">
          <div class="title">
            <h2>{{item.tit}}</h2>
            <p v-html=item.content></p>
          </div>
          <div class="pic">
            <img :src="item.oneUrl" alt="">
            <img :src="item.twoUrl" alt="">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/consultDetails.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
  data() {
    return {
      consultDetailsList: [
        { id: 0, oneUrl: require("@/assets/consult/1.png"), twoUrl: require("@/assets/consult/3.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '在使用数码复合机时，我们该注意些什么<br> 　　1. 复印纸张的正确防止。不当放置复印纸张可能导致卡纸现象，我们应该按照数码复合机说明将复印机纸张防止在纸盒内，在纸张选用中需选择高质量的复印纸张。纸张的选用中不单要选优质纸张，还需考虑到平整性，且放入纸盒内不能太满，进纸盒的导轨应该调到与纸张一样宽。<br> 　　2. 复印时出现卡纸现象时，按顺序关闭电源，将复印机侧门打开，将卡住的纸张慢慢取出，切勿强行取出，强行取出会导致纸张断裂而残留在复印机内，导致一些类问题，最后则是取出卡纸，切勿让感光鼓划伤。<br> 　３、复印机在复印文件时，尽量纸盒里面放的纸一定要平整，否则卡纸的几率会增加，特别注意，复印的纸张上有订书针的一定要取下来，在维修过程中经常会遇到，复印的时候订书针通过感光鼓的时候把感光鼓磨破导致需要更换感光鼓，造成不必要的损失。' },
        { id: 1, oneUrl: require("@/assets/consult/2.png"), twoUrl: require("@/assets/consult/2.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '在使用数码复合机时，我们该注意些什么<br> 　　1. 复印纸张的正确防止。不当放置复印纸张可能导致卡纸现象，我们应该按照数码复合机说明将复印机纸张防止在纸盒内，在纸张选用中需选择高质量的复印纸张。纸张的选用中不单要选优质纸张，还需考虑到平整性，且放入纸盒内不能太满，进纸盒的导轨应该调到与纸张一样宽。<br> 　　2. 复印时出现卡纸现象时，按顺序关闭电源，将复印机侧门打开，将卡住的纸张慢慢取出，切勿强行取出，强行取出会导致纸张断裂而残留在复印机内，导致一些类问题，最后则是取出卡纸，切勿让感光鼓划伤。<br> 　３、复印机在复印文件时，尽量纸盒里面放的纸一定要平整，否则卡纸的几率会增加，特别注意，复印的纸张上有订书针的一定要取下来，在维修过程中经常会遇到，复印的时候订书针通过感光鼓的时候把感光鼓磨破导致需要更换感光鼓，造成不必要的损失。' },
        { id: 2, oneUrl: require("@/assets/consult/3.png"), twoUrl: require("@/assets/consult/1.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '在使用数码复合机时，我们该注意些什么<br> 　　1. 复印纸张的正确防止。不当放置复印纸张可能导致卡纸现象，我们应该按照数码复合机说明将复印机纸张防止在纸盒内，在纸张选用中需选择高质量的复印纸张。纸张的选用中不单要选优质纸张，还需考虑到平整性，且放入纸盒内不能太满，进纸盒的导轨应该调到与纸张一样宽。<br> 　　2. 复印时出现卡纸现象时，按顺序关闭电源，将复印机侧门打开，将卡住的纸张慢慢取出，切勿强行取出，强行取出会导致纸张断裂而残留在复印机内，导致一些类问题，最后则是取出卡纸，切勿让感光鼓划伤。<br> 　３、复印机在复印文件时，尽量纸盒里面放的纸一定要平整，否则卡纸的几率会增加，特别注意，复印的纸张上有订书针的一定要取下来，在维修过程中经常会遇到，复印的时候订书针通过感光鼓的时候把感光鼓磨破导致需要更换感光鼓，造成不必要的损失。' },
      ],
    }
  },
}
</script>

<style>
</style>